<div class="mat-tooltip" [ngClass]="tooltipClass" [class.mat-tooltip-handset]="(_isHandset | async)!.matches" [style.transform-origin]="_transformOrigin" [@state]="_visibility" (@state.start)="_animationStart()" (@state.done)="_animationDone($event)">{{message}}</div>


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/@angular/material/tooltip/typings/index.d.ts.TooltipComponent.html